<script>
import AdvancedRubricPreviewTable from "@/components/rubrics/advanced_rubric_preview_table.vue";
import SimpleRubricPreviewTable from "@/components/rubrics/simple_rubric_preview_table.vue";

export default {
  name: "RubricPreviewTables",
  components: {
    AdvancedRubricPreviewTable,
    SimpleRubricPreviewTable,
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ["Advanced", "Simple", "Default"].includes(value),
    },
    criteria: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isAdvanced() {
      return this.type === "Advanced";
    },
    isDefault() {
      return this.type === "Default";
    },
  },
};
</script>

<template>
  <div class="rubric-preview-container">
    <AdvancedRubricPreviewTable v-if="isAdvanced" :criteria="criteria" />
    <SimpleRubricPreviewTable
      v-else
      :criteria="criteria"
      :is-default="isDefault"
    />
  </div>
</template>

<style lang="scss" scoped>
.rubric-preview-container {
  border-radius: var(--radius-rd-400, 12px);
  border: 1px solid var(--color-stroke-neutral-default, #e5ebf0);
  box-shadow: 3px 3px 20px 0 rgba(0, 0, 0, 0.04);
  background-color: white;
  overflow: hidden;

  ::v-deep {
    .table-responsive {
      margin-bottom: 0;
    }

    .table th,
    .table td,
    table.border {
      border: none !important;
    }

    tbody tr:nth-of-type(odd) {
      background: white;
    }

    thead tr,
    tbody tr:nth-of-type(even) {
      border-bottom: 1px solid var(--color-stroke-neutral-default, #e5ebf0);
      background-color: var(--color-surface-neutral-container-1, #f6f8fa);
    }

    tbody tr:last-of-type {
      border-bottom: none;
    }

    thead th {
      font-size: var(--typography-font-size-fs-200);
    }

    tbody td {
      padding: 1rem;
      font-size: var(--typography-font-size-fs-300);
    }
  }
}
</style>
